// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Paragraph from "components/typography/Paragraph";
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import Link from "components/layout/Link";

// ** Utils & Helpers
import DateTime from "utils/datetime";

// #####################################################

export const NewsItem = ({ url, heading, content, date }) => {
	const { t } = useTranslation(["pages"]);

	// #####################################################

	return (
		<Block mb={8}>
			<Block>
				<Link underline to={url}>
					<Text bold>{heading}</Text>
				</Link>
			</Block>

			<Text color="grey" small>
				{t("common:added")}: <time>{new DateTime(date).format()}</time>
			</Text>
			<Paragraph textBreak pt={2}>
				{content}
			</Paragraph>
		</Block>
	);
};

// #####################################################
